import React from 'react';
import { useFormikContext } from 'formik';
import { map } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Button, Accordion, Card } from 'react-bootstrap';

import { tOrdinalItem } from '@components/i18n';
import { StepFormProps } from '@components/Base';
import { CommissionShareField } from '@components/CommissionShareInput';
import { selectIsFrontline, selectCurrentUser } from '@components/Auth/selector';

import { FormValues } from './type';
import { ContactFormControl } from './contact-form-control';

const ContactStepForm = ({ onNext }: StepFormProps) => {
  const { t } = useTranslation();
  const { values } = useFormikContext<FormValues>();
  const isFrontline = useSelector(selectIsFrontline);
  const currentUser = useSelector(selectCurrentUser);

  return (
    <Card>
      <Card.Body>
        <Accordion defaultActiveKey="me">
          <ContactFormControl
            name="me"
            label={`${t('common:myself')} (${t('user.yearsOld', { age: values.me.age })})`}
          />

          {!!values.spouse && (
            <ContactFormControl
              name="spouse"
              label={`${t('common:spouse')} (${t('user.yearsOld', { age: values.spouse.age })})`}
            />
          )}

          {!!values.sons &&
            map(values.sons, (son, idx) => (
              <ContactFormControl
                key={`sons.${idx}`}
                name={`sons.${idx}`}
                label={`${tOrdinalItem(idx + 1, 'common:son')} (${t('user.yearsOld', { age: son.age })})`}
              />
            ))}

          {!!values.daughters &&
            map(values.daughters, (daughter, idx) => (
              <ContactFormControl
                key={`daughters.${idx}`}
                name={`daughters.${idx}`}
                label={`${tOrdinalItem(idx + 1, 'common:daughter')} (${t('user.yearsOld', { age: daughter.age })})`}
              />
            ))}
        </Accordion>
      </Card.Body>

      {isFrontline && currentUser && (
        <Card.Body>
          <Card.Title>{t('commissionShare.title')}</Card.Title>
          <CommissionShareField
            name="commissionShares"
            currentUserId={currentUser.id}
            currentUserName={currentUser.name}
          />
        </Card.Body>
      )}

      <Card.Footer>
        <div className="d-grid">
          <Button onClick={() => onNext()} size="lg">
            {t('common:next')}
          </Button>
        </div>
      </Card.Footer>
    </Card>
  );
};

export { ContactStepForm };
